import { createSelector } from 'reselect';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import { getFilters } from './propertyAvailabilitySelectors';

export const getActiveFilters = createSelector(getFilters, (filters) => keys(pickBy(filters, (filter) => !!filter)));
